const buildKey = (key: string): string => `user_preferences_${key}`;

export function getUserPreference(key: string): string | undefined {
  try {
    const value = localStorage.getItem(buildKey(key));
    return value !== null ? value : undefined;
  } catch (error) {
    console.error("Failed to get user preference:", error);
    return undefined;
  }
}

export function setUserPreference(
  key: string,
  value: string | undefined,
): void {
  try {
    if (value === undefined) {
      localStorage.removeItem(buildKey(key));
    } else {
      localStorage.setItem(buildKey(key), value);
    }
  } catch (error) {
    console.error("Failed to set user preference:", error);
  }
}

export function getUserPreferenceJSON<T>(key: string): T | undefined {
  try {
    const raw = getUserPreference(key);
    if (raw === undefined) return undefined;
    return JSON.parse(raw) as T;
  } catch {
    return undefined;
  }
}

export function setUserPreferenceJSON<T>(key: string, value: T): void {
  try {
    setUserPreference(key, JSON.stringify(value));
  } catch (error) {
    console.error("Failed to serialize user preference:", error);
  }
}
